import EFPicture from '@elem/compCommon/EFPicture';
import CardWatchBtn from '../../newcomp/CardWatchBtn';
import css from './index.module.scss';
import Modal from './Modal';
import { useGlobal } from '@/utils/useGlobal';

export default function NA1() {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra_daily_use.launch.detail');
    const [showModal, setShowModal] = useState(false);

    const arr = [
        {
            title: 'Name:',
            desc: 'Jason B.',
        },
        {
            title: 'Household Size:',
            desc: '2, including himself and his wife.',
        },
        {
            title: 'Location:',
            desc: 'Riverside, California',
        },
        {
            title: 'Product:',
            desc: '1 × EcoFlow DELTA Pro Ultra Inverter + 4 × Batteries + 1 × Smart Home Panel 2',
        },
        {
            title: 'Reason for Purchasing DPU is to save on electricity bills:',
            desc: 'With fewer than five outages per year but lasting long periods of time, there is a need for a reliable, long-term home backup power solution.',
        },
    ];

    const handleOpenModal = () => {
        setShowModal(true);
    };

    return (
        <section className={`dpu-detail-NA1 dpu-detail-section ${css['dpu-detail-NA1']}`}>
            <div className="text-info">
                <p className="subtitle">How EcoFlow DELTA Pro Ultra Transforms Energy Bills</p>
                <p className="title">Real savings, real stories</p>
            </div>
            {/* <CardWatchBtn /> */}
            <div className="box">
                <div className="profile">
                    <div className="author">
                        <EFPicture src={'/responsive/picture/delta-pro-ultra-daily-use/4.jpg'} alt={'Jason B**'} />
                    </div>
                    <ul className="author-info">
                        {arr?.map((item: any, k: number) => (
                            <li className="item" key={k}>
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="grid">
                    <p className="grid-title">Cost-Saving Experience:</p>
                    <p className="grid-desc">
                        {
                            '"Here\'s a comparison of March 2023 to March 2024: I cut my daily usage by more than half. The EcoFlow DELTA Pro Ultra and Smart Home Panel 2 run nearly every circuit except for my EV charger."'
                        }
                    </p>
                    <p className="grid-note">Daily average electricity usage (kWh)</p>
                    <div className="grid-content">
                        <div className="grid-img">
                            <EFPicture
                                src={'/responsive/picture/delta-pro-ultra-daily-use/4.png'}
                                srcPad={'/responsive/picture/delta-pro-ultra-daily-use/4_768.png'}
                                srcMobile={'/responsive/picture/delta-pro-ultra-daily-use/4_768.png'}
                                alt={'Daily average electricity usage (kWh)'}
                            />
                        </div>
                        <div className="grid-info">
                            <p className="info-text">
                                Electricity Bills Reduced in March<sup>1</sup>
                            </p>
                            <p className="info-strong">$170</p>
                            <p className="info-strong">61%</p>
                            <p className="info-bill" onClick={handleOpenModal}>
                                {'See detailed bills>'}
                            </p>
                        </div>
                    </div>
                    <div className="grid-content-tips-a">
                        * All information is based on the real user's experience. This user customizes bills through Time-of-Use and solar integration.
                    </div>
                </div>
            </div>
            {showModal && <Modal callback={() => setShowModal(false)} />}
        </section>
    );
}
